export default __webpack_public_path__ + "4c7ff67702f71c7801d8e4be99c68d29.png";